/* =====================================================
   assets/how-it-works-our-story-2026.js
   NuFace 2026 Redesign — Our Story "How It Works" video controller
   MS 2026-05-22

   Page-scoped controller for the Our Story (About) 2026 section.
   Mirrors the homepage how-it-works-2026.js mechanism — pause/play
   toggle plus auto-pause when offscreen — rewritten with
   section-scoped selectors / data attributes. Loaded only when the
   section has a video.
   ===================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.hiwOsInited === '1') return;
    section.dataset.hiwOsInited = '1';

    var video = section.querySelector('video.how-it-works-our-story-2026__video');
    var pauseBtn = section.querySelector('[data-hiw-os-pause]');
    if (!video || !pauseBtn) return;

    var autoplay = section.dataset.autoplay === 'true';
    var userPaused = !autoplay;

    function setBtnState(paused) {
      pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    pauseBtn.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked or other */ });
        userPaused = false;
        setBtnState(false);
      } else {
        video.pause();
        userPaused = true;
        setBtnState(true);
      }
    });

    /* Pause when offscreen, resume when back (unless user explicitly paused) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused && video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(section);
    }

    /* Keep button state in sync if the video pauses/plays for any other reason */
    video.addEventListener('pause', function () { setBtnState(true); });
    video.addEventListener('play',  function () { setBtnState(false); });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.how-it-works-our-story-2026');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
